export const SPACE_PALETTE = {
  void: '#05060a',
  voidDeep: '#0a0c14',
  armIndigo: '#1f2542',
  armViolet: '#3f2b5a',
  dust: '#554870',
  coreWarm: '#b89f70',
  nebulaSubtle: '#4a2a4a',
  star: '#e8e8f0',
};

export const SEEDS = {
  galaxy: 42,
  nebula: 123,
  asteroids: 7,
  dustText: 19,
};
